<template>
  <div style="padding: 10px 14px">
    <h3>Privacy Policy</h3>
    <p>
      Please carefully read this Guide and make sure you understand our rules for processing your personal information. If you have any questions while reading this Guide,
      please contact us.
      <strong>
        If you understand and agree to accept this Guide, you may click "Agree" to start receiving our services. If you do not agree to any clause in this Guide, please
        immediately stop accessing and using our services.
      </strong>
    </p>
    <strong><p>1. Scope of Application of the Privacy Policy</p></strong>
    <p>(1) Personal identification information you leave when using the server of this application;</p>
    <p>(2) Various types of information transmitted between you and other users or non-users through the server of this application;</p>
    <p>(3) Other information about you or non-users that this application shares with business partners;</p>
    <p>
      (4) We attach great importance to the protection of your personal privacy and have formulated the
      <em>User Privacy Policy</em>
      . You can also refer to the
      <em>User Privacy Policy</em>
      . By confirming and agreeing to use the services provided by this software, you shall be deemed to have accepted the
      <em>User Privacy Policy</em>
      .
    </p>
    <strong><p>2. Description of Collection and Use of User Information</p></strong>
    <strong>
      <p>
        <u>
          2.1 When you register and log in, we will collect and use your personal information, including but not limited to your nickname, avatar, mobile phone number, WeChat,
          and QQ. Such information is collected to help you complete registration, log in, and use the software services, as well as to protect the security of your account.
          We will collect and use the mobile phone number you voluntarily upload to conduct phone follow-ups and send activity notifications.
        </u>
      </p>
    </strong>
    <strong>
      <u>
        <p>
          2.2 After completing registration, you may choose to provide the following personal information: your school type, school stage information (e.g., primary school,
          junior high school, senior high school), and subject information (e.g., Chinese, Mathematics, English). To improve recognition, your nickname, school stage, and
          subject information will be publicly displayed (for example, after you upload or download courseware in the courseware library, such information will be displayed in
          the courseware library). If you do not provide the above information, it will not affect your use of the basic business functions of the software.
        </p>
      </u>
    </strong>
    <strong>
      <u>
        <p>
          2.3 Some of our services may require you to provide specific sensitive personal information to realize certain functions. If you choose not to provide such
          information, you may not be able to use specific functions in the services normally, but it will not affect your use of other functions in the services. If you
          voluntarily provide your sensitive personal information, it means you agree that we will process your sensitive personal information in accordance with the purposes
          and uses specified in this Policy or other prompts.
        </p>
      </u>
    </strong>
    <p>
      2.4 When collecting and using the above-mentioned information, we will need to obtain relevant permissions from you, such as camera, photo album, and microphone
      permissions. None of these permissions will be enabled by default; they will only be granted to us after you explicitly agree. It should be specially noted that
      obtaining relevant permissions is a necessary prerequisite for us to provide relevant functions. However, our acquisition of a specific permission does not mean that we
      will necessarily collect your relevant information. Even if we have obtained relevant permissions, we will only collect your relevant information when necessary and in
      accordance with this Guide.
    </p>
    <p>
      2.5 Please understand that the functions and services we provide to you are constantly updated and developed. If a certain function or service is not mentioned in the
      above description but indeed requires the collection of your information, we will separately inform you of the content, scope, and purpose of the information collection
      through methods such as updating this Policy, page prompts, interactive processes, and offline notifications, and obtain your consent.
    </p>
    <strong><p>3. Description of Disclosure of User Information</p></strong>
    <p>
      3.1 Respecting users' personal privacy is one of our basic policies. Therefore, we will not disclose, edit, or reveal users' registration data and non-public content
      stored in this application without the authorization of legitimate users, except in the following cases:
    </p>
    <p>(1) Required by relevant laws and regulations, or necessary for performing statutory duties or obligations;</p>
    <p>(2) Directly related to national security, national defense security, public security, public health, and major public interests;</p>
    <p>(3) Directly related to criminal investigation, prosecution, trial, and execution of judgments;</p>
    <p>(4) To protect the trademark rights, patent rights, and any other legitimate rights and interests of ourselves or affiliated companies;</p>
    <p>
      (5) To respond to public health emergencies, or in emergency situations to protect the life, property, and other major legitimate rights and interests of you or other
      individuals;
    </p>
    <p>
      (6) Processing your voluntarily disclosed personal information or other legally disclosed personal information within a reasonable scope in accordance with the
      provisions of the
      <em>Personal Information Protection Law of the People's Republic of China</em>
      , unless you explicitly refuse. When the collected information has a significant impact on your personal rights and interests, we will obtain your consent in accordance
      with the law;
    </p>
    <p>(7) Collecting personal information from legally publicly disclosed information, such as legal news reports, government information disclosure channels, etc.;</p>
    <p>(8) Necessary for maintaining the safe and stable operation of the provided products or services, such as detecting and handling faults of products or services;</p>
    <p>(9) Other circumstances that require the disclosure, editing, or revelation of personal information.</p>
    <strong><p>4. Storage of Information</p></strong>
    <p>
      4.1 We will use various security protection measures within a reasonable security level to ensure the security of your personal information.
      <strong>
        <u>
          However, please understand that due to technical limitations and rapid development in the Internet industry, as well as the existence of various potential malicious
          attack methods, even if we do our utmost to strengthen security measures, we cannot always guarantee 100% security of information. Therefore, we cannot guarantee the
          security or integrity of any personal information during two-way transmission via the Internet.
        </u>
      </strong>
    </p>
    <p>
      4.2 Storage Location: We will store the collected personal information on servers located within the territory of China in accordance with the requirements of applicable
      Chinese laws and regulations. Without your consent, we will not transmit your personal information overseas.
    </p>
    <p>
      4.3 In general, we will only store your information for the shortest period required by law. After the expiration of this period, your information will be deleted.
      However, in the following cases, we may need to change the storage period of personal information to comply with legal requirements:
    </p>
    <p>(1) To comply with applicable laws, regulations, and other relevant provisions;</p>
    <p>(2) To comply with court judgments, rulings, or other legal procedures;</p>
    <p>(3) To comply with the requirements of relevant government authorities or legally authorized organizations;</p>
    <p>(4) We have reasonable grounds to believe that it is necessary to comply with laws, regulations, and other relevant provisions;</p>
    <p>
      (5) For the purpose of implementing relevant service agreements or this Guide, safeguarding public interests, and protecting the personal and property safety or other
      legitimate rights and interests of our customers, ourselves, affiliated companies, other users, or employees.
    </p>
    <p>
      4.4 We will store your personal information in accordance with laws and regulations, and store the user personal information collected within the territory of China
      within China. Currently, we will not transmit or store your personal information across borders. If cross-border transmission or storage is required in the future, we
      will conduct such transmission and storage in accordance with the requirements of relevant laws and regulations.
    </p>
    <strong><p>5. Disclosure and Sharing of Information</p></strong>
    <p>5.1 We will not intentionally disclose, rent, or sell your personal information and data to any third party, except in the following cases:</p>
    <p>(1) You yourself agree to share information and data with a third party;</p>
    <p>(2) Disclosure of your personal information and data is necessary to provide a certain product or service you request;</p>
    <p>
      (3) Provision of information is required by the entity that provides products or services on behalf of this application (unless we notify you otherwise, such entities
      have no right to use the relevant personal information and data of you for purposes other than providing products or services); provision of information is required by
      laws, regulations, or administrative orders; provision of information is required for external auditing purposes; you have violated the service terms of this application
      or the usage regulations of any other products and services; after our assessment, your account is at risk and needs to be protected.
    </p>
    <p>
      5.2 When you use our services, you agree that your personal information may be disclosed to other teachers in your class and students in the class. Except for this, we
      will not share your personal information with any third-party companies, organizations, or individuals, except in the following cases:
    </p>
    <p>(1) Sharing with explicit consent: After obtaining your explicit consent, we will share your personal information with other parties;</p>
    <p>
      (2) We may share your personal information with external parties in accordance with the provisions of laws and regulations or the mandatory requirements of government
      authorities;
    </p>
    <p>
      (3) Sharing with our affiliated companies: Your personal information may be shared with our affiliated companies. We will only share necessary personal information, and
      such sharing will be subject to the purposes stated in this Privacy Policy. If an affiliated company needs to change the purpose of processing personal information, it
      will seek your authorization and consent again;
    </p>
    <p>(4) Sharing with products under the {{ activationCompany.abbreviation }} brand.</p>
    <strong><p>6. Your Rights Regarding Your Personal Information</p></strong>
    <p>
      6.1 During your use of our products and services, to enable you to access and manage information more conveniently and protect your right to cancel your account, we have
      provided corresponding operation settings in the client. You can follow the guidelines therein to perform operations. At the same time, you can also contact us through
      this Policy to request to view, correct, or delete your personal information.
    </p>
    <p>6.2 You may contact our customer service to request the deletion of the corresponding personal information under the following circumstances:</p>
    <p>
      (1) We collect, store, use, or provide personal information to external parties in violation of the provisions of laws, administrative regulations, or the agreement
      between both parties;
    </p>
    <p>(2) We collect, store, use, or provide personal information to external parties beyond the scope of the purpose or the necessary period;</p>
    <p>(3) You withdraw your consent;</p>
    <p>(4) You terminate the use of all our products or services by means of account cancellation, etc.</p>
    <p>6.3 Responding to Your Above Requests</p>
    <p>
      For security purposes, you may be required to provide a written request or verify your identity in other ways. We may first ask you to verify your identity before
      processing your request.
    </p>
    <strong><p>7. Protection of Minors</p></strong>
    <p>
      We attach importance to the protection of minors' personal information. Due to the nature of this software, we do not provide this software and its services to minors.
      During your use of our services, we presume that you have the corresponding capacity for civil conduct.
      <strong>
        <u>
          If you are a minor, before using the relevant services of this software, you should carefully read this Privacy Policy under the supervision and guidance of your
          parents or other guardians, and provide information to us only with the consent of your parents or guardians.
        </u>
      </strong>
    </p>
    <strong><p>8. Changes</p></strong>
    <p>
      We may revise this Guide from time to time. When the clauses of this Guide are changed, we will prompt you of the revised Privacy Protection Guide in an appropriate
      manner when updating the version and inform you of the effective date.
      <strong>
        <u>
          Please carefully read the content of the revised Privacy Protection Guide. You need to indicate your consent to our processing of your personal information in
          accordance with the updated Privacy Protection Guide by clicking "Agree", checking the consent box, or other means again.
        </u>
      </strong>
    </p>
    <strong><p>9. How to Contact Us</p></strong>
    <p>
      If you have any questions, comments, or suggestions regarding this Privacy Policy, please contact us through the following methods. We will reply to you in a timely
      manner in accordance with the requirements of applicable laws and regulations:
    </p>
    <p>Company: {{ activationCompany.company }}</p>
    <p>Tel: 400-632-8880</p>
    <p>Contact Person: Customer Service Specialist</p>
    <p>Address: {{ activationCompany.address }}</p>
    <p>
      We will review the relevant issues as soon as possible and reply to you in a timely manner after verifying your user identity. Generally, we will reply to your request
      within 15 working days. If we are unable to respond to your request, we will send you a notification and explain the reason within the time limit required by law. If you
      are not satisfied with our reply, especially if our personal information processing actions have damaged your legitimate rights and interests, you may also seek a
      solution through the following external channels:
      <strong>
        <u>File a lawsuit with the local court in the place where Dongguan Sunvol Information Technology Co., Ltd. is registered.</u>
      </strong>
    </p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: 'Dongguan Sunvol Information Technology Co., Ltd.',
        address: 'Block A, Building 11, Area C, Songshanlake International Financial Park, Dongguan City, Guangdong Province',
        abbreviation: 'Sunvol'
      }
    }
  },
  created() {
    // this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}
.underline {
  text-decoration: underline;
}
.primaryColor {
  color: #1e80ff;
}
</style>
